import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { 
  FormControl, 
  TextField, 
  Button, 
  Box, 
  Alert, 
  AlertTitle, 
  Stack,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Paper,
  IconButton,
  InputAdornment,
  Divider,
  Avatar,
  Chip,
  List,
  ListItem,
  CircularProgress
} from "@mui/material";

import { 
  CalendarToday, 
  AccessTime, 
  Person, 
 
  Close,
  Check,
  Phone,
  Notes,
  Event
} from "@mui/icons-material";
import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
  limit,
} from "firebase/firestore";
import { db } from "../../../firebaseConfig/firebase";
import axios from "axios";

// const token = process.env.REACT_APP_API_KEYTOKEN;
// const mytoken = process.env.REACT_APP_API_KEYMYTOKEN;
// const phidtoken = process.env.REACT_APP_API_KEYphidtoken;

function Appointment() {
  let navigate = useNavigate();
  const location = useLocation();
  
  const [showAlert, setShowAlert] = useState(false);
  const [name, setName] = useState('');
  const [name2, setName2] = useState(true);
  const [phNumber, setphNumber] = useState("");
  const [time, setTime] = useState("");
  const [duration, setDuration] = useState("");
  const [reason, setReason] = useState("");
  const [ptId, setptId] = useState();
  const [docid, setdocid] = useState();
  const [photoURL, setPhotoURL] = useState("");
  const [isLocked, setIsLocked] = useState(false);
  const [date, setDate] = useState(new Date(Date.now()));
  const [data, setData] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [dateAppointments, setDateAppointments] = useState([]);
  const [nextApptOption, setNextApptOption] = useState("treatment");
  const [nextApptType, setNextApptType] = useState("Treatment");
  const [opdId, setOpdId] = useState(null);

  let datew = typeof date === "string" ? date : JSON.stringify(date).slice(1, 11);
  if (datew && datew.includes('"')) {
    datew = datew.replace(/"/g, '');
  }

  let originalDate = datew || "";
  let splitDate = originalDate.split("-");
  let convertedDate = splitDate.length === 3 ? `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}` : originalDate;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!docid || !ptId) {
      alert("Please select a patient from the search results.");
      return;
    }

    if (!time || time.trim() === "" || time === "Choose a Time") {
      alert("Please select an Appointment Time before scheduling.");
      return;
    }
    
    const militaryTime = time;
    const hours = Math.floor(militaryTime / 100);
    const minutes = militaryTime % 100;
    const timeString = `${hours % 12 || 12}:${minutes.toString().padStart(2, '0')} ${hours < 12 ? 'AM' : 'PM'}`;
    
    console.log(name, convertedDate, time, timeString, ptId, reason);

    const AppointmentDetails = {
      docid: docid,
      patientId: ptId,
      name: name,
      phNumber: phNumber,
      photoURL: photoURL,
      date: datew,
      reason: reason,
      time: time,
      duration: duration,
      timeString: timeString,
      nextApptOption: nextApptOption || "treatment",
      nextApptType: nextApptType || "Treatment",
      created: serverTimestamp(),
    };

    await addDoc(collection(db, "AppointmentDetails"), AppointmentDetails);

    // If originated from OPD entry, update the opdEntry document as well
    if (opdId) {
      try {
        const opdRef = doc(db, "opdEntry", opdId);
        await updateDoc(opdRef, {
          nextApptOption: nextApptOption || "treatment",
          nextApptType: nextApptType || "Treatment",
          nextApptWork: reason || "",
          nextApptDate: datew,
          nextApptDuration: duration || "",
          isApptGiven: true,
        });
      } catch (opdErr) {
        console.error("Error updating opdEntry doc from appointment:", opdErr);
      }
    }

    // WhatsApp notification: IF IT IS A FOLLOW-UP TYPE, DO NOT SEND MSG TO PATIENT!
    if (nextApptOption !== "followup" && nextApptType !== "Follow-Up") {
      try {
        axios
          .post(
            "https://expressapi-avwxc4hazq-uc.a.run.app/appointmentAdd",
            {
              name: name,
              phno: phNumber,
              convertedDate: convertedDate,
              timeString: timeString,
            },
            {
              headers: {
                "Content-type": "application/json; charset=UTF-8",
              },
            }
          )
          .then((res) => {
            console.log("WhatsApp message sent successfully:", res);
          });
      } catch (whatsappError) {
        console.error("WhatsApp notification failed:", whatsappError);
        // Continue even if WhatsApp fails
      }
    } else {
      console.log("Skipping WhatsApp message because appointment type is Follow-Up.");
    }


    setShowAlert(true);

    setName("");
    setTime("");
    setDate("");
    setReason("");
    setDuration("");
    setPhotoURL("");
    setName2(true);
    
    setTimeout(() => {
      setShowAlert(false);
      navigate(-1);
    }, 1500);
  };

  const clearSelection = () => {
    setName("");
    setphNumber("");
    setptId(null);
    setdocid(null);
    setPhotoURL("");
    setIsLocked(false);
    setName2(true);
  };

  const handleChangeTime = (event) => {
    setTime(event.target.value);
  };

  const handleChangeDuration = (event) => {
    setDuration(event.target.value);
  };

  const handleDateChange = (newDate) => {
    if (newDate) {
      const dateObj = new Date(newDate);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      setDate(formattedDate);
    }
  };

  // Time options for dropdown
  const timeOptions = [
    { value: "", label: "Choose a Time" },
    { value: "1000", label: "10:00 AM" },
    { value: "1030", label: "10:30 AM RCT" },
    { value: "1100", label: "11:00 AM" },
    { value: "1130", label: "11:30 AM" },
    { value: "1200", label: "12:00 PM" },
    { value: "1230", label: "12:30 PM RCT" },
    { value: "1300", label: "01:00 PM RCT" },
    { value: "1600", label: "04:00 PM RCT" },
    { value: "1630", label: "04:30 PM" },
    { value: "1700", label: "05:00 PM" },
    { value: "1730", label: "05:30 PM" },
    { value: "1800", label: "06:00 PM RCT" },
    { value: "1830", label: "06:30 PM" },
    { value: "1900", label: "07:00 PM" },
    { value: "1930", label: "07:30 PM" },
  ];

  // Duration options for dropdown
  const durationOptions = [
    { value: "", label: "Select Duration" },
    { value: "15 Mins", label: "15 Minutes" },
    { value: "30 Mins", label: "30 Minutes" },
    { value: "45 Mins", label: "45 Minutes" },
    { value: "1 Hr", label: "1 Hour" },
    { value: "1.5Hrs", label: "1.5 Hours" },
    { value: "2 Hrs", label: "2 Hours" },
    { value: "2.5 Hrs", label: "2.5 Hours" },
    { value: "3 Hrs", label: "3 Hours" },
  ];

  // 15-by-15 Scroll Pagination & 4-sec Debounce States
  const [fetchLimit, setFetchLimit] = useState(15);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    setFetchLimit(15);
    setHasMore(true);
  }, [name]);

  const handlePatientSearchScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 30) {
      if (hasMore && !loadingMore && !searchLoading) {
        setFetchLimit((prev) => prev + 15);
      }
    }
  };

  // Fetch patient data when name changes with 4-second debounce & 15-item scroll pagination
  useEffect(() => {
    if (isLocked || name.trim() === "") {
      setData([]);
      setSearchLoading(false);
      setLoadingMore(false);
      setHasMore(false);
      return;
    }

    if (fetchLimit === 15) {
      setSearchLoading(true);
    } else {
      setLoadingMore(true);
    }

    const delayDebounce = setTimeout(() => {
      const patientProfile = collection(db, "patientProfile");
      const abc = name.toLowerCase().trim();

      const qd = query(
        patientProfile,
        where("namearray", "array-contains", abc),
        orderBy("created", "desc"),
        limit(fetchLimit)
      );

      const unsub = onSnapshot(qd, (snap) => {
        let newArray = [];

        snap.forEach((doc) => {
          newArray.push({
            ...doc.data(),
            docid: doc.id,
            ptId: doc.get("ptId"),
            ptname: doc.get("name"),
            phoneNumber: doc.get("phNumber"),
            DOB: doc.get("DOB"),
            age: doc.get("age"),
            gender: doc.get("gender"),
            photoURL: doc.get("photoURL"),
            created: doc.get("created"),
            TotalAmount: doc.get("TotalAmount"),
            paid: doc.get("paid"),
          });
        });

        setData(newArray);
        setSearchLoading(false);
        setLoadingMore(false);

        if (snap.docs.length < fetchLimit) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      });

      return () => unsub();
    }, 4000); // 4-second debounce to reduce Firestore data fetch

    return () => clearTimeout(delayDebounce);
  }, [name, isLocked, fetchLimit]);
  
  // Fetch appointments for selected date
  useEffect(() => {
    if (datew) {
      const appointmentData = collection(db, "AppointmentDetails");
      
      const qd = query(
        appointmentData,
        where("date", "==", datew),
        orderBy("time", "asc")
      );
      
      const unsub = onSnapshot(qd, (snap) => {
        let newArray = [];
        
        snap.forEach((doc) => {
          newArray.push({
            ...doc.data(),
            id: doc.get("patientId"),
            ptName: doc.get("name"),
            docid: doc.id,
            timeString: doc.get("timeString"),
            phoneNumber: doc.get("phNumber"),
            duration: doc.get("duration"),
            reason: doc.get("reason"),
            appointmentDate: doc.get("date"),
            appointmentTime: doc.get("time"),
            created: doc.get("created"),
            type: doc.get("type"),
            isRescheduled: doc.get("isRescheduled"),
          });
        });
        
        console.log("Appointments for date:", newArray);
        setDateAppointments(newArray);
      });
      
      return () => {
        unsub();
      };
    }
  }, [datew]);
  
  // Handle auto-fill from location state
  useEffect(() => {
    if (location.state) {
      const {
        name: ptName,
        phoneNumber,
        id,
        originalptId,
        photoURL: ptPhoto,
        reason: ptReason,
        nextApptWork,
        date: ptDate,
        nextApptDate,
        duration: ptDuration,
        nextApptDuration,
        nextApptOption: ptOption,
        nextApptType: ptType,
        opdId: ptOpdId
      } = location.state;

      if (ptName) setName(ptName);
      if (phoneNumber) setphNumber(phoneNumber);
      if (id) setptId(id);
      if (originalptId || id) setdocid(originalptId || id);
      if (ptPhoto) setPhotoURL(ptPhoto);
      if (ptReason || nextApptWork) setReason(ptReason || nextApptWork);
      if (ptDate || nextApptDate) setDate(ptDate || nextApptDate);
      if (ptDuration || nextApptDuration) setDuration(ptDuration || nextApptDuration);
      if (ptOption) {
        setNextApptOption(ptOption);
        setNextApptType(ptOption === "followup" ? "Follow-Up" : "Treatment");
      } else if (ptType) {
        setNextApptType(ptType);
        setNextApptOption(ptType === "Follow-Up" ? "followup" : "treatment");
      }
      if (ptOpdId) setOpdId(ptOpdId);

      setName2(false); // Hide search dropdown
      setIsLocked(true);
    }
  }, [location.state]);

  return (
    <Box sx={{ 
      backgroundColor: "#f4f6f9", 
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      pb: "100px", // Extra bottom padding for Bottombar
      boxSizing: "border-box"
    }}>
      {/* Header */}
      <Box
        sx={{
          height: "48px",
          background: "linear-gradient(135deg, rgb(5, 2, 43) 0%, rgb(18, 25, 75) 100%)",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1.5,
          boxShadow: "0 2px 10px rgba(5, 2, 43, 0.2)",
          flexShrink: 0
        }}
      >
        <IconButton 
          onClick={() => navigate(-1)} 
          sx={{ color: "white", p: 0.5 }}
        >
          <ArrowBackIosIcon sx={{ fontSize: "1rem" }} />
        </IconButton>
        <Typography variant="subtitle1" sx={{ fontSize: "0.95rem", fontWeight: 700 }}>
          Schedule Appointment
        </Typography>
        <Chip
          label={convertedDate}
          size="small"
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.15)",
            color: "white",
            fontWeight: 600,
            fontSize: "0.75rem",
            height: "24px"
          }}
        />
      </Box>

      {/* Success Alert */}
      {showAlert && (
        <Stack 
          sx={{ 
            width: '100%', 
            position: 'absolute', 
            zIndex: '999',
            top: "48px" 
          }} 
          spacing={2}
        >
          <Alert 
            severity="success"
            sx={{
              borderRadius: "0px 0px 8px 8px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              py: 0.5
            }}
          >
            <AlertTitle sx={{ fontSize: "0.85rem", mb: 0 }}>Success</AlertTitle>
            Appointment added successfully
          </Alert>
        </Stack>
      )}

      {/* Main Content */}
      <Box sx={{ 
        p: 1.5, 
        flex: 1,
        display: "flex",
        flexDirection: "column"
      }}>
        <Box sx={{ 
          display: "flex", 
          flexDirection: { xs: "column", md: "row" },
          width: "100%"
        }}>
          {/* Form Section */}
          <Box sx={{ 
            flexBasis: { xs: "auto", md: "65%" },
            flexGrow: 1,
            flexShrink: 0,
            mr: { xs: 0, md: 1.5 },
            width: "100%",
            position: "relative"
          }}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: "14px",
                p: 2,
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.04)",
                border: "1px solid #e8ecef",
                backgroundColor: "#ffffff",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column"
              }}
            >
              <Typography variant="subtitle1" sx={{ mb: 1.5, fontWeight: 700, color: "#0a0d25", fontSize: "0.95rem" }}>
                Patient Information
              </Typography>

              <form noValidate autoComplete="off" onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column" }}>
                <Box>
                  {/* Patient Name Field */}
                  <Box sx={{ mb: 2, position: "relative" }}>
                    <TextField
                      id="patient-name"
                      label="Patient Name"
                      value={name}
                      onChange={(e) => !isLocked && setName(e.target.value)}
                      variant="outlined"
                      fullWidth
                      required
                      size="small"
                      autoComplete="off"
                      InputProps={{
                        readOnly: isLocked,
                        style: { fontSize: "1.05rem" },
                        startAdornment: (
                          <InputAdornment position="start">
                            <Person color={isLocked ? "primary" : "action"} sx={{ fontSize: "1.3rem" }} />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            {searchLoading && <CircularProgress size={18} sx={{ mr: 1, color: "rgb(5, 2, 43)" }} />}
                            {(isLocked || name) && (
                              <IconButton 
                                size="small" 
                                onClick={clearSelection}
                              >
                                <Close fontSize="small" />
                              </IconButton>
                            )}
                          </InputAdornment>
                        )
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: isLocked ? "#f8fafc" : "white",
                        }
                      }}
                    />
                    {isLocked && (
                      <Box sx={{ mt: 0.5, display: "flex", alignItems: "center", gap: 1, px: 0.5 }}>
                        <Chip 
                          icon={<Phone sx={{ fontSize: "0.85rem !important" }} />}
                          label={phNumber}
                          size="small"
                          sx={{ 
                            height: "26px", 
                            fontSize: "0.85rem", 
                            bgcolor: "#f1f5f9",
                            color: "#1e293b",
                            fontWeight: 700,
                            border: "1px solid #e2e8f0"
                          }}
                        />
                      </Box>
                    )}

                    {/* Patient Search Results */}
                    {data.length > 0 && name2 && (
                      <Paper
                        elevation={3}
                        onScroll={handlePatientSearchScroll}
                        sx={{
                          position: "absolute",
                          top: "50px",
                          left: 0,
                          right: 0,
                          zIndex: 1000,
                          maxHeight: "240px",
                          overflowY: "auto",
                          borderRadius: "10px",
                          boxShadow: "0 6px 24px rgba(0,0,0,0.15)"
                        }}
                      >
                        <List disablePadding>
                          {data.map((item, index) => (
                            <React.Fragment key={item.docid}>
                              <ListItem
                                button
                                onClick={() => {
                                  setdocid(item.docid);
                                  setName(item.ptname);
                                  setptId(item.ptId || item.docid);
                                  setphNumber(item.phoneNumber);
                                  setPhotoURL(item.photoURL || "");
                                  setData([]);
                                  setName2(false);
                                  setIsLocked(true);
                                }}
                                sx={{
                                  py: 1.25,
                                  px: 2,
                                  transition: "all 0.2s",
                                  "&:hover": {
                                    backgroundColor: "#f0f7ff"
                                  }
                                }}
                              >
                                <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                                  <Avatar 
                                    src={item.photoURL}
                                    sx={{ 
                                      bgcolor: "#e3f2fd", 
                                      color: "#1976d2",
                                      width: 40, 
                                      height: 40,
                                      mr: 1.5,
                                      fontSize: "1rem",
                                      fontWeight: 700
                                    }}
                                  >
                                    {item.ptname.charAt(0).toUpperCase()}
                                  </Avatar>
                                  <Box sx={{ flex: 1 }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#0a0d25", fontSize: "1.05rem" }}>
                                        {item.ptname}
                                      </Typography>
                                      <Chip 
                                        size="small" 
                                        label={`${item.age} yrs • ${item.gender}`} 
                                        sx={{ 
                                          bgcolor: "#f0f7ff", 
                                          color: "#1e293b",
                                          fontWeight: 600,
                                          fontSize: "0.75rem",
                                          height: "22px"
                                        }} 
                                      />
                                    </Box>
                                    {item.phoneNumber && (
                                      <Typography variant="caption" sx={{ color: "#2563eb", fontWeight: 700, display: "block", mt: 0.25 }}>
                                        📞 {item.phoneNumber}
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                              </ListItem>
                              {index < data.length - 1 && <Divider />}
                            </React.Fragment>
                          ))}
                          {loadingMore && (
                            <Box sx={{ display: "flex", justifyContent: "center", py: 1 }}>
                              <CircularProgress size={20} />
                            </Box>
                          )}
                        </List>
                      </Paper>
                    )}
                  </Box>

                  {/* Reason Field */}
                  <Box sx={{ mb: 2 }}>
                    <TextField
                      id="reason"
                      label="Reason for Appointment"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      variant="outlined"
                      fullWidth
                      size="small"
                      required
                      InputProps={{
                        style: { fontSize: "0.95rem" },
                        startAdornment: (
                          <InputAdornment position="start">
                            <Notes color="action" sx={{ fontSize: "1.2rem" }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>

                  {/* Appointment Details */}
                  <Paper
                    elevation={0}
                    sx={{
                      borderRadius: "12px",
                      p: 2,
                      mb: 2,
                      backgroundColor: "#f8f9fa",
                      border: "1px solid #e9ecef"
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ mb: 1.75, fontWeight: 700, color: "#0a0d25", fontSize: "0.95rem" }}>
                      Appointment Details
                    </Typography>

                    {/* Appointment Type (Non-editable) */}
                    <Box 
                      sx={{ 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center", 
                        mb: 1.5
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Event sx={{ color: "#1976d2", mr: 1, fontSize: "1.1rem" }} />
                        <Typography sx={{ color: "#444", fontWeight: 600, fontSize: "0.9rem" }}>
                          Type:
                        </Typography>
                      </Box>
                      <Chip
                        label={nextApptOption === "followup" || nextApptType === "Follow-Up" ? "Follow-Up (No SMS)" : "Treatment"}
                        size="small"
                        sx={{
                          fontWeight: 600,
                          fontSize: "0.8rem",
                          height: "26px",
                          backgroundColor: nextApptOption === "followup" || nextApptType === "Follow-Up" ? "#e0f2f1" : "#e3f2fd",
                          color: nextApptOption === "followup" || nextApptType === "Follow-Up" ? "#00695c" : "#1565c0",
                          border: nextApptOption === "followup" || nextApptType === "Follow-Up" ? "1px solid #b2dfdb" : "1px solid #bbdefb",
                          px: 1
                        }}
                      />
                    </Box>

                    {/* Date Selection */}
                    <Box 
                      sx={{ 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center", 
                        mb: 1.5
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <CalendarToday sx={{ color: "#1976d2", mr: 1, fontSize: "1.1rem" }} />
                        <Typography sx={{ color: "#444", fontWeight: 600, fontSize: "0.9rem" }}>
                          Date:
                        </Typography>
                      </Box>
                      <TextField
                        type="date"
                        variant="outlined"
                        size="small"
                        value={datew}
                        onChange={(e) => setDate(e.target.value)}
                        InputProps={{
                          sx: {
                            backgroundColor: "white",
                            borderRadius: "8px",
                            fontSize: "0.9rem",
                            height: "38px",
                            "& fieldset": {
                              borderColor: "#e0e0e0"
                            }
                          }
                        }}
                        sx={{ width: "165px" }}
                      />
                    </Box>

                    {/* Time Selection */}
                    <Box 
                      sx={{ 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center", 
                        mb: 1.5
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <AccessTime sx={{ color: "#1976d2", mr: 1, fontSize: "1.1rem" }} />
                        <Typography sx={{ color: "#444", fontWeight: 600, fontSize: "0.9rem" }}>
                          Time <span style={{ color: "red", fontWeight: "bold" }}>*</span>:
                        </Typography>
                      </Box>
                      
                      <FormControl sx={{ width: "165px" }} required error={!time} size="small">
                        <Select
                          value={time}
                          onChange={handleChangeTime}
                          displayEmpty
                          required
                          size="small"
                          sx={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            fontSize: "0.9rem",
                            height: "38px",
                            "& fieldset": {
                              borderColor: !time ? "#d32f2f" : "#e0e0e0"
                            }
                          }}
                        >
                          {timeOptions.map(option => (
                            <MenuItem key={option.value} value={option.value} sx={{ fontSize: "0.9rem" }}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>

                    {/* Duration Selection */}
                    <Box 
                      sx={{ 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center"
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <AccessTime sx={{ color: "#1976d2", mr: 1, fontSize: "1.1rem" }} />
                        <Typography sx={{ color: "#444", fontWeight: 600, fontSize: "0.9rem" }}>
                          Duration:
                        </Typography>
                      </Box>
                      
                      <FormControl sx={{ width: "165px" }} size="small">
                        <Select
                          value={duration}
                          onChange={handleChangeDuration}
                          displayEmpty
                          size="small"
                          sx={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            fontSize: "0.9rem",
                            height: "38px",
                            "& fieldset": {
                              borderColor: "#e0e0e0"
                            }
                          }}
                        >
                          {durationOptions.map(option => (
                            <MenuItem key={option.value} value={option.value} sx={{ fontSize: "0.9rem" }}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Paper>
                </Box>

                {/* Submit Button */}
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  startIcon={<Check sx={{ fontSize: "1.3rem" }} />}
                  sx={{
                    py: 1.5,
                    mt: 2,
                    mb: 4,
                    background: "linear-gradient(135deg, rgb(5, 2, 43) 0%, rgb(20, 30, 80) 100%)",
                    color: "white",
                    borderRadius: "10px",
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: "1rem",
                    letterSpacing: "0.5px",
                    boxShadow: "0 4px 16px rgba(5, 2, 43, 0.4)",
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      background: "linear-gradient(135deg, rgb(10, 5, 60) 0%, rgb(30, 42, 100) 100%)",
                      boxShadow: "0 6px 20px rgba(5, 2, 43, 0.5)",
                      transform: "translateY(-1px)"
                    },
                    "&:active": {
                      transform: "translateY(0)"
                    }
                  }}
                >
                  Schedule Appointment
                </Button>
              </form>
            </Paper>
          </Box>
          
          {/* Appointments Section */}
          <Box sx={{ 
            flexBasis: { xs: "auto", md: "35%" },
            flexGrow: 1,
            overflow: "auto",
            display: { xs: "none", md: "block" },
            height: { md: "calc(100vh - 80px)" },
            position: "sticky",
            top: "70px"
          }}>


          
            <Paper
              elevation={0}
              sx={{
                borderRadius: "16px",
                p: 3,
                boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                maxHeight: "calc(100vh - 80px)"
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Event sx={{ color: "#1976d2", mr: 1 }} />
                <Typography variant="h6" sx={{ fontWeight: 600, color: "#0a0d25" }}>
                  Appointments on {convertedDate}
                </Typography>
              </Box>
              
              <Divider sx={{ mb: 2 }} />
              
              <Box sx={{ 
                flex: 1,
                overflowY: "auto",
                pr: 1
              }}>
                {dateAppointments.length > 0 ? (
                  dateAppointments.map((apt, index) => (
                    <Paper
                      key={index}
                      elevation={0}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "white",
                        borderRadius: "12px",
                        border: "1px solid #f0f0f0",
                        mb: 2,
                        p: 2,
                        transition: "all 0.2s ease",
                        "&:hover": {
                          boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
                        },
                      }}
                    >
                      <Box display="flex" alignItems="center" mb={1}>
                        <Avatar
                          sx={{
                            width: 40,
                            height: 40,
                            fontSize: "0.8rem",
                            bgcolor: apt.type === "pending" ? "#ffebee" : apt.isRescheduled ? "#fff3e0" : "#e3f2fd",
                            color: apt.type === "pending" ? "#d32f2f" : apt.isRescheduled ? "#f57c00" : "#1976d2",
                            mr: 1.5,
                          }}
                        >
                          {apt.timeString.split(" ")[0] || apt.time.split(" ")[0]}
                        </Avatar>
                        <Box flexGrow={1}>
                          <Typography variant="subtitle2" fontWeight={600} color="#111">
                            {apt.ptName || apt.name}
                          </Typography>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mt={0.5}
                          >
                            <Typography variant="caption" color="text.secondary">
                              {apt.timeString}
                            </Typography>
                            <Box display="flex" gap={0.5}>
                              {apt.type === "pending" && (
                                <Chip
                                  label="Pending"
                                  size="small"
                                  sx={{
                                    height: "20px",
                                    fontSize: "0.675rem",
                                    bgcolor: "#ffebee",
                                    color: "#d32f2f",
                                  }}
                                />
                              )}
                              {apt.isRescheduled && (
                                <Chip
                                  label="Rescheduled"
                                  size="small"
                                  sx={{
                                    height: "20px",
                                    fontSize: "0.675rem",
                                    bgcolor: "#fff3e0",
                                    color: "#f57c00",
                                  }}
                                />
                              )}
                              <Chip
                                label={apt.duration}
                                size="small"
                                sx={{
                                  height: "20px",
                                  fontSize: "0.675rem",
                                  bgcolor: "#f5f5f5",
                                  color: "#555",
                                }}
                              />
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                      
                      <Box sx={{ pl: 7 }}>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                        >
                          {apt.reason}
                        </Typography>
                        
                        {apt.phoneNumber && (
                          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                            <Phone sx={{ fontSize: "0.875rem", color: "#9e9e9e", mr: 0.5 }} />
                            <Typography variant="caption" color="text.secondary">
                              {apt.phoneNumber}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Paper>
                  ))
                ) : (
                  <Box 
                    sx={{ 
                      display: "flex", 
                      flexDirection: "column", 
                      alignItems: "center", 
                      justifyContent: "center",
                      height: "200px",
                      p: 3
                    }}
                  >
                    <Event sx={{ fontSize: "3rem", color: "#e0e0e0", mb: 2 }} />
                    <Typography variant="body1" sx={{ color: "#666", textAlign: "center" }}>
                      No appointments scheduled for this date
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#999", textAlign: "center", mt: 1 }}>
                      Schedule your first appointment using the form
                    </Typography>
                  </Box>
                )}
              </Box>
            </Paper>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Appointment;